/**
 * Mixin to handle loading state reset on navigation
 * Fixes the issue where loading spinners persist after browser back navigation
 */
export default {
  mounted() {
    // Reset loading state when component is mounted/remounted
    if (this.isLoading !== undefined) {
      this.isLoading = false;
    }
  },
  
  activated() {
    // Reset loading state when component is activated (for keep-alive components)
    if (this.isLoading !== undefined) {
      this.isLoading = false;
    }
  },
  
  watch: {
    '$route'() {
      // Reset loading state when route changes (handles browser back button)
      if (this.isLoading !== undefined) {
        this.isLoading = false;
      }
    }
  }
};
